@if (canUpload) {
  <p-fileUpload #fileUploader (uploadHandler)="upload($event)" multiple="multiple"
    customUpload="true">
    <ng-template #file let-file>
      <div>
        <div>@if (isImage(file)) {
          <img [src]="file.objectURL" [width]="50" />
        }</div>
        <div>{{file.name | fileName}}</div>
        <div>{{formatSize(file.size)}}</div>
        <div><p-autoComplete [(ngModel)]="file.category" placeholder="Category" [suggestions]="results" [dropdown]="true" [suggestions]="categories" (completeMethod)="search($event)" ></p-autoComplete> </div>
        <div><span class="ui-float-label">
          <textarea id="float-input" rows="5" cols="30" pInputTextarea
          [(ngModel)]="file.description"></textarea>
          <label for="float-input">Description</label>
        </span> </div>
        <div>
          <button type="button" pButton (click)="remove($event,file)" [disabled]="_fileUploader.uploading">
            <i pButtonIcon class="pi pi-times"></i>
          </button>
        </div>
      </div>
    </ng-template>
  </p-fileUpload>
}

<p-table [value]="files" [resizableColumns]="true" >
  <ng-template #header>
    <tr>
      <th pResizableColumn width="150">Category</th>
      <th pResizableColumn width="200" >File</th>
      @if (canUpload) {
        <th pResizableColumn width="50" ></th>
      }
      <th pResizableColumn>Description</th>
    </tr>
  </ng-template>
  <ng-template #body let-file let-rowIndex="rowIndex">
    <tr>

      @if (rowGroupMetadata[getCategory(file)].index === rowIndex) {
        <td [attr.rowspan]="rowGroupMetadata[getCategory(file)].size">
          {{getCategory(file)}}
        </td>
      }
      <td>
        @if (!isLink(file)) {
          <a [href]="getHref(file)" target="_blank" > {{file.name | fileName}}</a>
        }
        @if (isLink(file)) {
          <div [innerHTML]="getFileContent(file.name)"></div>
        }
      </td>
      @if (canUpload) {
        <td>
          <button type="button" pButton (click)="confirmDelete($event,file)">
            <i pButtonIcon class="pi pi-times"></i>
          </button>
        </td>
      }
      <td><div [innerHTML]="formatDescription(getMeta(file, 'description'))"></div></td>
    </tr>
  </ng-template>
</p-table>

